import * as React from 'react'
import { useIndustryResources } from './IndustryResourcesProvider'
import { cn } from '../../../lib/utils'
import {
  HeartOutlineIcon,
  HeartSolidIcon,
} from '~/components/job_search/RecruiterSearchPage/Icons'

export default function ResourceCard({ resource }) {
  const {
    selectedResource,
    handleSelectResource,
    isSavedResource,
    addToConnections,
    removeFromMyConnections,
  } = useIndustryResources()
  const selected = selectedResource && selectedResource?.id === resource?.id

  const description = resource.description
    ? resource.description
        .replace(/<[^>]*>?/gm, ' ')
        .replace(/\|\|\|/g, '')
        .replace(/\|\|/g, '')
        .split(' ')
        .filter((word) => word.length <= 40)
        .join(' ')
    : ''

  const firstContact = resource.contacts && resource.contacts[0]

  const toggleResource = () => {
    if (isSavedResource(resource)) {
      removeFromMyConnections(resource, firstContact)
    } else addToConnections(resource, firstContact)
  }

  const handleCardClick = (event) => {
    handleSelectResource(resource)(event)
  }

  return (
    <li
      className="relative flex cursor-pointer flex-row gap-4 rounded-2xl border-2 p-4 transition-colors hover:border-gray-400 hover:shadow-lg data-[selected=true]:border-intoo-blue-bright"
      data-selected={selected}
      onClick={handleCardClick}
    >
      <div className="relative flex min-w-full flex-col gap-4">
        <div
          onClick={toggleResource}
          className={cn(
            'absolute right-0',
            isSavedResource(resource) && 'text-[#A50000]',
          )}
        >
          <SavedStatusIcon resource={resource} />
        </div>

        <div className="flex flex-row justify-start gap-4">
          <div className="flex flex-col gap-1">
            <h4 className="pr-10 font-extrabold">{resource.name}</h4>
            <p className="line-clamp-3 text-xs">{description}</p>
          </div>
        </div>
      </div>
    </li>
  )
}

const SavedStatusIcon = ({ resource }) => {
  const { isSavedResource } = useIndustryResources()

  const saved = isSavedResource(resource)

  if (saved) return <HeartSolidIcon />
  return <HeartOutlineIcon />
}
